//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Cookies from "js-cookie";

export default {
  data() {
    return {
      user: {
        loggedIn: false,
        firstName: "",
        lastName: ""
      }
    };
  }
};
